import React from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import HomePage from '../routes/HomePage';
import CategoryPage from '../routes/CategoryPage';
import CategoryVideoPlay from '../routes/CategoryVideoPlay';
import CategoryPage2 from '../routes/CategoryPage2';
import CategoryContentPage from '../routes/CategoryContentPage';
import GamePage from '../routes/GamePage';
import WordGameDetails from '../routes/WordGameDetails';
import Layout from '../components/Layout';
import WordGameOver from '../routes/WordGameOver';
import WordGamePlay from '../routes/WordGamePlay';
import XOGameDetails from '../routes/XOGameDetails';
import XOGamePlay from '../routes/XOGamePlay';
import XOGameOver from '../routes/XOGameOver';

const Routing = () => {
    const router = createBrowserRouter([{
        path: "/",
        element: <HomePage />
    },
    {
        path: "/category",
        element: <CategoryPage />
    },
    {
        path: "/category/content/:category",
        element: <CategoryContentPage />
    },
    {
        path: "/category/video/play",
        element: <CategoryVideoPlay />
    },
    {
        path: "/game/:gameTitle",
        element: (
            <>
                <GamePage />
            </>
        )
    },
    {
        path: "/word-game-details",
        element:
            <Layout>
                <WordGameDetails />
            </Layout>
        ,
    },
    {
        path: "/word-game-over",
        element:
            <Layout>
                <WordGameOver />
            </Layout>
    },
    {
        path: "/word-game",
        element:
            <WordGamePlay />
        ,
    },
    {
        path: "/xo-game-details",
        element: <Layout> <XOGameDetails /> </Layout>,
    },
    {
        path: "/xo-game",
        element: <XOGamePlay />,
    },
    {
        path: "/xo-game-over",
        element: <Layout><XOGameOver /></Layout>,
    },
    {
        path: "*",
        element: <Navigate to={"/"} />
    }
    ])

    return (
        <RouterProvider router={
            router
        } />
    )
}

export default Routing